<section class="d-flex flex-column gap-32">
  <h1 class="access-restricted-title" i18n>Access Restricted</h1>
  <div class="d-flex flex-column gap-4 align-items-start">
    <p class="access-restricted-message" i18n>
      Your access to the member portal has been restricted. Contact CSS for help.
    </p>
    <app-text-button (buttonClicked)="contactCss()" i18n>Contact CSS</app-text-button>
  </div>
</section>
